(function () {
  'use strict';

  var fmt = function (v) {
    var n = typeof v === 'string' ? parseFloat(v) : v / 100;
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function init(root) {
    if (root.dataset.mhReady) return;
    root.dataset.mhReady = '1';
    var html = document.documentElement;
    var head = root.querySelector('[data-mh-head]');

    /* ---------- Header height for sticky elements on the page ---------- */
    function setHeight() {
      var h = head ? head.getBoundingClientRect().height : 0;
      html.style.setProperty('--header-desktop-sticky-height', Math.round(h) + 'px');
      html.style.setProperty('--mh-height', Math.round(h) + 'px');
    }
    setHeight();
    window.addEventListener('resize', setHeight);
    var onScroll = function () { root.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ---------- Announcement bar rotation (mobile) ---------- */
    var bar = root.querySelector('[data-mh-bar]');
    var msgs = bar ? bar.querySelectorAll('.mh-bar__msg') : [];
    if (msgs.length > 1) {
      var bi = 0;
      bar.classList.add('is-ready');
      msgs[0].classList.add('is-on');
      setInterval(function () {
        msgs[bi].classList.remove('is-on');
        bi = (bi + 1) % msgs.length;
        msgs[bi].classList.add('is-on');
      }, 4000);
    }

    /* ---------- Mega dropdowns ---------- */
    var items = root.querySelectorAll('.mh-nav__item.has-drop');
    var closeTimer;
    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var a = it.querySelector('.mh-nav__link');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (it) {
      var link = it.querySelector('.mh-nav__link');
      var open = function () {
        clearTimeout(closeTimer);
        closeAll(it);
        closeSearch();
        it.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      };
      it.addEventListener('mouseenter', open);
      it.addEventListener('mouseleave', function () { closeTimer = setTimeout(function () { closeAll(); }, 160); });
      it.addEventListener('focusin', open);
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches && !it.classList.contains('is-open')) { e.preventDefault(); open(); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeSearch(); closeDrawer(); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) { closeAll(); closeSearch(); } });

    /* ---------- Search ---------- */
    var panel = root.querySelector('[data-mh-search]');
    var q = root.querySelector('[data-mh-q]');
    var res = root.querySelector('[data-mh-results]');
    var tags = root.querySelector('[data-mh-tags]');
    var openBtn = root.querySelector('[data-mh-search-open]');
    function openSearch() {
      if (!panel) return;
      closeAll();
      panel.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { q && q.focus(); }, 30);
    }
    function closeSearch() {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }
    if (openBtn) openBtn.addEventListener('click', function (e) { e.stopPropagation(); panel.hidden ? openSearch() : closeSearch(); });
    root.querySelectorAll('[data-mh-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
    var timer, last = '', ctrl;
    var card = function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
      var cmp = parseFloat(p.compare_at_price_max || 0), pr = parseFloat(p.price || 0);
      var sale = cmp > pr ? Math.round((cmp - pr) / cmp * 100) : 0;
      return '<article class="mc"><a class="mc__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img class="mc__img" src="' + esc(img) + '" alt="" loading="lazy">' : '') +
        '<span class="mc__badges">' + (sale ? '<span class="mc__badge mc__badge--sale">−' + sale + ' %</span>' : '') + (p.available === false ? '<span class="mc__badge">Ausverkauft</span>' : '') + '</span></a>' +
        '<div class="mc__body">' + (p.vendor ? '<p class="mc__vendor">' + esc(p.vendor) + '</p>' : '') +
        '<h3 class="mc__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        '<p class="mc__price">' + (p.price_max && parseFloat(p.price_max) > pr ? '<span class="mc__from">ab</span> ' : '') + '<b>' + fmt(p.price) + '</b>' + (sale ? ' <s>' + fmt(cmp) + '</s>' : '') + '</p></div></article>';
    };
    var hl = function (text, term) {
      var t = esc(text), i = t.toLowerCase().indexOf(term.toLowerCase());
      return i < 0 ? t : t.slice(0, i) + '<mark>' + t.slice(i, i + term.length) + '</mark>' + t.slice(i + term.length);
    };
    if (q && res) {
      q.addEventListener('input', function () {
        clearTimeout(timer);
        var term = q.value.trim();
        var idle = term.length < 2;
        if (tags) tags.hidden = !idle;
        res.hidden = idle;
        if (idle) { res.innerHTML = ''; last = ''; return; }
        if (!res.innerHTML) res.innerHTML = '<p class="mh-res__loading">Suche läuft …</p>';
        timer = setTimeout(function () {
          if (term === last) return;
          last = term;
          if (ctrl && ctrl.abort) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last';
          fetch(url, ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var r = (d.resources && d.resources.results) || {};
              var ps = r.products || [], cs = r.collections || [], qs = r.queries || [];
              var all = '/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
              if (!ps.length && !cs.length) {
                res.innerHTML = '<div class="mh-res__none"><b>Keine Treffer für „' + esc(term) + '“</b><span>Versuch es mit einer Marke oder Duftnote.</span></div>';
                return;
              }
              var side = '';
              if (qs.length) side += '<p class="mh-search__h">Vorschläge</p><ul class="mh-res__q">' + qs.slice(0, 5).map(function (x) {
                return '<li><a href="' + esc(x.url) + '">' + (x.styled_text || hl(x.text, term)) + '</a></li>'; }).join('') + '</ul>';
              if (cs.length) side += '<p class="mh-search__h">Kategorien</p><ul class="mh-search__cats">' + cs.slice(0, 4).map(function (c) {
                return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '<span>→</span></a></li>'; }).join('') + '</ul>';
              res.innerHTML = (side ? '<div class="mh-search__side">' + side + '</div>' : '') +
                '<div class="mh-search__main"><p class="mh-search__h">Produkte</p><div class="mh-search__grid">' + ps.slice(0, 4).map(card).join('') + '</div>' +
                '<a class="mh-res__all" href="' + all + '">Alle Ergebnisse für „' + esc(term) + '“ anzeigen →</a></div>';
            })
            .catch(function () {});
        }, 160);
      });
    }

    /* ---------- Mobile drawer ---------- */
    var drawer = root.querySelector('[data-mh-drawer]');
    var openD = root.querySelector('[data-mh-open]');
    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      html.classList.add('mh-lock');
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      if (openD) openD.setAttribute('aria-expanded', 'true');
      var f = drawer.querySelector('[data-mh-close]:not(.mh-drawer__scrim)');
      if (f) f.focus();
    }
    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      html.classList.remove('mh-lock');
      if (openD) { openD.setAttribute('aria-expanded', 'false'); openD.focus(); }
      setTimeout(function () { drawer.hidden = true; }, 350);
    }
    if (openD) openD.addEventListener('click', openDrawer);
    root.querySelectorAll('[data-mh-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

    /* ---------- Cart ---------- */
    var cartBtn = root.querySelector('[data-mh-cart]');
    var count = root.querySelector('[data-mh-count]');
    function setCount(n) {
      if (!count) return;
      var old = parseInt(count.textContent, 10) || 0;
      count.textContent = n;
      count.hidden = !n;
      if (n > old && cartBtn) { cartBtn.classList.remove('is-bump'); void cartBtn.offsetWidth; cartBtn.classList.add('is-bump'); }
    }
    if (cartBtn) {
      cartBtn.addEventListener('click', function (e) {
        if (typeof window.emit === 'function' && document.querySelector('.quick-cart')) {
          e.preventDefault();
          window.emit('quick-cart:open');
        }
      });
    }
    var hook = function () {
      if (typeof window.on !== 'function') return false;
      window.on('cart:updated', function (d) { if (d && d.cart && typeof d.cart.item_count === 'number') setCount(d.cart.item_count); });
      window.on('quick-cart:updated', function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
      });
      return true;
    };
    if (!hook()) window.addEventListener('load', hook);
  }

  function boot() { document.querySelectorAll('[data-mh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
